import { Tooltip } from "antd";
import type { ReactNode } from "react";

type TimelineControlButtonProps = {
  label: string;
  testId?: string;
  isActive?: boolean;
  onClick: () => void;
  tooltip?: string;
  icon?: ReactNode;
  variant?: "tab" | "secondary";
};

export default function TimelineControlButton({
  label,
  testId,
  isActive = false,
  onClick,
  tooltip,
  icon,
  variant = "tab",
}: TimelineControlButtonProps) {
  const tabStyles = isActive
    ? "bg-white text-[#2B4752]"
    : "bg-[#E1E3E3] text-[#7C7D7D]";
  const secondaryStyles = isActive
    ? "border border-[#64BDE1] bg-[#ECFAFF] text-[#2B4752]"
    : "border border-[#0000001f] bg-[rgba(255,255,255,0.7)] text-[#2B4752]";

  const button = (
    <button
      type="button"
      className={`flex items-center gap-1.5 rounded-md px-3 py-2 text-sm ${
        variant === "secondary"
          ? `shadow-[0px_4px_20px_0px_rgba(0,0,0,0.05)] ${secondaryStyles}`
          : `font-bold ${tabStyles}`
      }`}
      data-testid={testId}
      onClick={onClick}
    >
      {icon ? <span className="text-sm leading-none">{icon}</span> : null}
      <span>{label}</span>
    </button>
  );

  if (!tooltip) return button;

  return (
    <Tooltip title={tooltip} mouseEnterDelay={0.3}>
      {button}
    </Tooltip>
  );
}
